import React, { useEffect, useState } from 'react';
import client from '../../../api/client';

export default function SLASettings() {
  const [locations, setLocations] = useState([]);
  const [saving, setSaving] = useState({});
  const [saved, setSaved] = useState({});

  useEffect(() => {
    client.get('/config/contract-dates/').then(r => setLocations(r.data)).catch(() => {});
  }, []);

  const onChange = (id, val) => {
    setLocations(ls => ls.map(l => l.id === id ? { ...l, contract_start_date: val } : l));
  };

  const save = async (loc) => {
    setSaving(s => ({ ...s, [loc.id]: true }));
    await client.patch(`/config/contract-dates/${loc.id}/`, {
      contract_start_date: loc.contract_start_date || null,
    });
    setSaving(s => ({ ...s, [loc.id]: false }));
    setSaved(s => ({ ...s, [loc.id]: true }));
    setTimeout(() => setSaved(s => ({ ...s, [loc.id]: false })), 2000);
  };

  return (
    <div className="space-y-4">
      <div className="card overflow-hidden">
        <div className="px-6 py-4 border-b border-brand-50">
          <h2 className="font-bold text-brand-500 text-sm">Contract Start Dates by Location</h2>
          <p className="text-xs text-gray-400 mt-0.5">SLA and penalty calculations begin from this date for each location</p>
        </div>
        <div className="overflow-x-auto">
          <table className="w-full text-sm">
            <thead>
              <tr style={{ background: 'linear-gradient(to right, #F5F3FC, #EAE7F8)' }}>
                <th className="px-4 py-3 text-left text-xs font-bold text-brand-400 uppercase tracking-wider">Location</th>
                <th className="px-4 py-3 text-left text-xs font-bold text-brand-400 uppercase tracking-wider">City</th>
                <th className="px-4 py-3 text-center text-xs font-bold text-brand-400 uppercase tracking-wider">SLA Class</th>
                <th className="px-4 py-3 text-left text-xs font-bold text-brand-400 uppercase tracking-wider">Contract Start Date</th>
                <th className="px-4 py-3"></th>
              </tr>
            </thead>
            <tbody className="divide-y divide-brand-50">
              {locations.map(loc => (
                <tr key={loc.id} className="hover:bg-brand-50/40 transition-colors">
                  <td className="px-4 py-3 font-medium text-gray-800">{loc.name}</td>
                  <td className="px-4 py-3 text-gray-500">{loc.city}</td>
                  <td className="px-4 py-3 text-center">
                    <span className={`inline-flex px-2 py-0.5 rounded-full text-xs font-bold ${
                      loc.sla_class === 'A' ? 'bg-brand-100 text-brand-600' : 'bg-gray-100 text-gray-500'
                    }`}>Class {loc.sla_class}</span>
                  </td>
                  <td className="px-4 py-3">
                    <input
                      type="date"
                      value={loc.contract_start_date || ''}
                      onChange={e => onChange(loc.id, e.target.value)}
                      className="input-field w-44 text-sm"
                    />
                  </td>
                  <td className="px-4 py-3">
                    {saved[loc.id] ? (
                      <span className="text-emerald-600 text-xs font-semibold">✓ Saved</span>
                    ) : (
                      <button
                        onClick={() => save(loc)}
                        disabled={saving[loc.id]}
                        className="text-xs font-semibold px-3 py-1.5 bg-brand-500 text-white rounded-lg hover:bg-brand-600 transition-colors disabled:opacity-50"
                      >
                        {saving[loc.id] ? 'Saving…' : 'Save'}
                      </button>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
